// sessionStorage key helpers (scoped to top of file)
const filtersKey = (layerId) => `attrTable_filters_${layerId}`;
const spatialKey  = (layerId) => `attrTable_spatial_${layerId}`;

export default {
  namespaced: true,

  state: {
    visible: false,
    layer: null,
    attributes: [],
    totalFeatures: 0,
    spatialFilter: null,
    columnFilters: {},           // ← NEW
  },

  mutations: {
    SHOW_TABLE(state, payload) {
      state.visible = true;
      state.layer = payload.layer;
      state.attributes = payload.attributes || [];
      state.totalFeatures = payload.totalFeatures || 0;
      state.columnFilters = payload.columnFilters || {};    // ← NEW: restored from sessionStorage
      state.spatialFilter = payload.spatialFilter || null;  // ← NEW: restored from sessionStorage
    },

    // ← NEW: used by updateTable() — only updates data rows, never touches filters
    UPDATE_ATTRIBUTES(state, payload) {
      state.attributes = payload.attributes || [];
      state.totalFeatures = payload.totalFeatures || 0;
    },

    HIDE_TABLE(state) {
      state.visible = false;
      state.layer = null;
      state.attributes = [];
      state.totalFeatures = 0;
      state.spatialFilter = null;
      state.columnFilters = {};
    },

    SET_SPATIAL_FILTER(state, extent) {
      state.spatialFilter = extent;
    },

    CLEAR_SPATIAL_FILTER(state) {
      state.spatialFilter = null;
    },

    // ← NEW
    SET_COLUMN_FILTER(state, { key, val }) {
      state.columnFilters = { ...state.columnFilters, [key]: val };
      if (state.layer) {
        sessionStorage.setItem(
          filtersKey(state.layer.id),
          JSON.stringify(state.columnFilters)
        );
      }
    },

    // ← NEW
    CLEAR_COLUMN_FILTERS(state) {
      state.columnFilters = {};
      if (state.layer) {
        sessionStorage.removeItem(filtersKey(state.layer.id));
      }
    },
  },

  actions: {
    openTable({ commit }, payload) {
      const layerId = payload.layer.id;
      // Restore persisted filters from sessionStorage
      const savedFilters = sessionStorage.getItem(filtersKey(layerId));
      const savedSpatial = sessionStorage.getItem(spatialKey(layerId));
      commit("SHOW_TABLE", {
        ...payload,
        columnFilters: savedFilters ? JSON.parse(savedFilters) : {},
        spatialFilter: savedSpatial ? JSON.parse(savedSpatial) : null,
      });
    },

    // ← NEW: called by updateTable() for pagination / filter data refresh
    updateAttributes({ commit }, payload) {
      commit("UPDATE_ATTRIBUTES", payload);
    },

    closeTable({ commit, state }) {
      // Persist spatialFilter before clearing (Q10=B: WMS filter persists after close)
      if (state.layer && state.spatialFilter) {
        sessionStorage.setItem(
          spatialKey(state.layer.id),
          JSON.stringify(state.spatialFilter)
        );
      }
      commit("HIDE_TABLE");
    },

    setSpatialFilter({ commit, state }, extent) {
      if (state.layer) {
        sessionStorage.setItem(spatialKey(state.layer.id), JSON.stringify(extent));
      }
      commit("SET_SPATIAL_FILTER", extent);
    },

    clearSpatialFilter({ commit, state }) {
      if (state.layer) {
        sessionStorage.removeItem(spatialKey(state.layer.id));
      }
      commit("CLEAR_SPATIAL_FILTER");
    },

    setColumnFilter({ commit }, payload) {   // ← NEW
      commit("SET_COLUMN_FILTER", payload);
    },

    clearColumnFilters({ commit }) {         // ← NEW
      commit("CLEAR_COLUMN_FILTERS");
    },
  },

  getters: {
    isVisible:     (s) => s.visible,
    layer:         (s) => s.layer,
    attributes:    (s) => s.attributes,
    totalFeatures: (s) => s.totalFeatures,
    spatialFilter: (s) => s.spatialFilter,
    columnFilters: (s) => s.columnFilters,  // ← NEW
  }
};
